import { actionTypesEnum } from '../enum';

export const getNotaCreditoPorEmisor = (state = null, action) => {

  if (action.type === actionTypesEnum.getNotaCreditoPorEmisor) {
    return action.payload;
  }

  return state;
};
